var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row g-0 mt-5 mb-5"},[_c('carousel',{attrs:{"autoplay":true,"perPageCustom":[
        [0, 1],
        [576, 1],
        [768, 2],
        [992, 2],
        [1200, 3] ]}},_vm._l((_vm.reviews),function(review,index){return _c('slide',{key:index},[_c('ReviewCard',{attrs:{"customer-name":review.name,"review-text":review.text,"rating":review.rating}})],1)}),1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }